import MyJobApi from './MyJobApi'
import * as config from '../config.js'
var Api = new MyJobApi({
  url: config.API_ROOT
})

export default Api
